import { Component, OnInit } from '@angular/core';
import { CategoryService } from '../_services/category.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AddcategoryComponent } from './addcategory/addcategory.component';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css']
})
export class CategoryComponent implements OnInit {

 hammeddeler:any[]=[];
  filteredhammeddeler:any[]=[];
  constructor(
    private hammaddeService:CategoryService,
    private modal:NgbModal,
    private toastr: ToastrService) { }
  @BlockUI('changelog') blockUIChangelog: NgBlockUI;
  ngOnInit() {
    this.getHammaddeler();
  }


  getHammaddeler(){
    this.blockUIChangelog.start('Loading..');
    this.hammaddeService.getCompounds().subscribe(res=>{
      this.hammeddeler=res;
      this.filteredhammeddeler=res;
      this.blockUIChangelog.stop();
    },err=>{
      this.blockUIChangelog.stop();
    });
  }

  openSaveModal(){
    const modalref=  this.modal.open(AddcategoryComponent, { size: 'lg' });
   
    modalref.result.then((result)=>{
     this.getHammaddeler();
    });
    }

    openEditModal(data:any){
      const modalref=  this.modal.open(AddcategoryComponent, { size: 'xl' });
      modalref.componentInstance.hammadde=data;
      modalref.result.then((result)=>{
       this.getHammaddeler();
      });
      }


    delete(id){
        this.hammaddeService.deleteCompounds(id).subscribe(res=>{
          this.getHammaddeler();
          this.toastr.success('', 'Kayıt silindi');
        });
    }

   
}

